import React, { FC } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { change, formValueSelector } from 'redux-form'
import { actions as LKModalActions } from '../../shared/LKModal'
import { OpenButton } from '../../AccountForm'
import { accountViewBase } from 'src/store/account'
import { AppDispatch } from 'src/store/index.d'

const CreditAccountAddButton: FC<{
  FormName: string
  disabled: boolean
  instanceName?: string
  chooseAccount?: boolean
  chooseClient?: boolean
  fetcherName?: string
  formValue?: string
}> = ({ instanceName, FormName, disabled, chooseAccount = true, formValue = 'CCY' }) => {
  const dispatch = useDispatch<AppDispatch>()

  const ccy: string = useSelector((state) => formValueSelector(FormName)(state, formValue))

  function fetchAccountInformation(data) {
    // dispatch(
    //   fetchSFM({
    //     instanceName,
    //     callApi: Account.details,
    //     callApiArgs: [data],
    //   }),
    //   //@ts-ignore
    // ).then(({ Data }) => {
    //   if (Data.CCY === ccy && chooseAccount) {
    //     //@ts-ignore
    //     dispatch([
    //       change(FormName, 'CreditAccNo', Data.AccNo),
    //       change(FormName, 'CreditTitleUNI', Data.TitleUNI),
    //       change(FormName, 'CreditAccID', data.ID),
    //       change(FormName, 'CreditAccHash', data.hash),
    //       change(FormName, 'CreditAccBalance', Data.Balance),
    //     ])
    //   }
    // })

    //UPDATED API REQUEST acc_account_view_api page: base
    dispatch(
      accountViewBase({
        AccountID: data.ID,
        HashSum_AccountID_: data.hash,
      }),
    )
      .then((response) => {
        if (!accountViewBase.fulfilled.match(response)) {
          throw new Error((response.payload as any).message)
        }
        const { payload: Data } = response
        if (Data.CCY === ccy && chooseAccount) {
          //@ts-ignore
          dispatch([
            change(FormName, 'CreditAccNo', Data.AccNo),
            change(FormName, 'CreditTitleUNI', Data.TitleUNI),
            change(FormName, 'CreditAccID', data.ID),
            change(FormName, 'CreditAccHash', data.hash),
            change(FormName, 'CreditAccBalance', Data.Balance),
          ])
        }
      })
      .catch((e) => {
        dispatch(LKModalActions.openError(e.message))
      })
  }

  return (
    //@ts-ignore
    <OpenButton name="CreditAccountAdd" icon="account_add" disabled={disabled} onSuccess={fetchAccountInformation} />
  )
}

export default CreditAccountAddButton
